import { render, staticRenderFns } from "./ItemBrand.vue?vue&type=template&id=37190f2c&"
import script from "./ItemBrand.vue?vue&type=script&lang=ts&"
export * from "./ItemBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports